<div class="pie-chart">
  <canvas [id]="canvasId"></canvas>
  @if (!hasData) {
    <p class="pie-chart__empty">Sem dados para exibir.</p>
  }
</div>
